import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { Button } from '@tkww/the-bash-frontend';

import { SectionContainer } from 'components/grid';

const StyledSectionContainer = styled(SectionContainer)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: 'calc(100% - 32px)',
  padding: '56px 16px',
  textAlign: 'center',
  [theme.breakpoints.up('md')]: {
    width: '100%',
    padding: '56px 0 68px',
  },
}));

const StyledHeading = styled(Typography)(({ theme }) => ({
  marginTop: 0,
  marginBottom: theme.spacing(1),
}));

const StyledSubHeading = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

const LearnMoreCtaSection = ({ title, subtitle, onLearnMoreClick, backgroundColor }) => (
  <StyledSectionContainer backgroundColor={backgroundColor}>
    <StyledHeading variant="h2">{title}</StyledHeading>
    <StyledSubHeading variant="body1">{subtitle}</StyledSubHeading>
    <Button onClick={onLearnMoreClick} type="secondary" sx={{ margin: 'auto' }}>
      Learn More
    </Button>
  </StyledSectionContainer>
);

LearnMoreCtaSection.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  onLearnMoreClick: PropTypes.func.isRequired,
  backgroundColor: PropTypes.string,
};

LearnMoreCtaSection.defaultProps = {
  backgroundColor: null,
};

export default LearnMoreCtaSection;
